import type {CarrierOption} from '@/types/CarrierOption';
import useCarriers from '@/composables/useCarriers/useCarriers';
import {hasMainContract, isEnabled} from '@/utils/carriers';

export const getActiveCarriers = async (): Promise<CarrierOption[]> => {
  const {getAccountCarriers} = useCarriers();
  const carriers = await getAccountCarriers();

  return carriers.value.reduce<CarrierOption[]>((acc, carrier) => {
    if (!hasMainContract(carrier)) {
      return acc;
    }

    if (!isEnabled(carrier)) {
      return acc;
    }

    const hasDuplicate =
      acc.length &&
      acc.some((currentCarrier) => {
        return currentCarrier.carrier_id === carrier.carrier_id;
      });

    if (hasDuplicate) {
      return acc;
    }

    return [...acc, carrier];
  }, []);
};
